<!-- <div> -->
<div *ngIf="chatService.noAccessToChat" class="noAccess">
    You have no access to this chat. Please contact admin.
</div>
<div class="chatBox" fxLayout="column" [class.fx73]="!chatBoxMax" [class.blur-effect]="chatService.noAccessToChat">
    <div class="chatHeader">
        <div class="header">
            <button mat-icon-button *ngIf="mobileView" matTooltip="Back to list" matTooltipPosition="below"
                class="backToList" (click)="backToList()">
                <i class="flaticon-down-chevron"></i>
            </button>
            <i class="flaticon-chat"></i>
            <div class="vstack">
                <div class="reqDetails">
                    <span class="request_no">
                        {{requestNumber ? requestNumber : requestDetails?.request_number}}
                    </span>
                    <!-- <span class="discussion"> Discussion Thread</span> -->
                </div>
                <span class="activities"> Last Activity <br> {{ lastActivity | date: "d-MMM h:mm a" }}</span>
                <span class="activities"> {{ connectionStatus }} </span>
            </div>
            <ng-container *ngIf="!mobileView">
                <span *ngIf="compact" class="chooser" [class.cselected]="choosed=='chat'"
                    (click)="choosingTab('chat')">Chat</span>
                <span *ngIf="compact" class="chooser" [class.cselected]="choosed=='file'"
                    (click)="choosingTab('file')">Files</span>
                <span *ngIf="compact" class="chooser" [class.cselected]="choosed=='user'"
                    (click)="choosingTab('user')">Participants ({{ threadUsers.length }})</span>
            </ng-container>
        </div>
        <div class="actions">

            <ng-container *ngIf="disconSocket">
                <i class="flaticon-refresh-page-option" [class.recon]="reconnecting"
                    [class.disconnectedSocket]="disconSocket" (click)="reconnectChat()" matTooltip="Reconnect"></i>
            </ng-container>
            <!-- <i class="flaticon-phone-call" disabled="" [matTooltip]="'Feature Coming Soon'"></i>
            <i class="flaticon-video-call" disabled="" [matTooltip]="'Feature Coming Soon'"></i> -->
            <ng-container *ngIf="!compact">
                <i [ngClass]="
                        chatBoxMax ? 'flaticon-minimize' : 'flaticon-maximize'
                    " (click)="toggleChatBox(chatBoxMax)" matTooltip="Resize"></i>
            </ng-container>
            <ng-container *ngIf="mobileView">
                <button mat-icon-button [matMenuTriggerFor]="mobileMenu">
                    <i class="flaticon-more"></i>
                </button>
                <mat-menu #mobileMenu="matMenu">
                    <button mat-menu-item (click)="choosingTab('chat')" [class.d-none]="choosed=='chat'">
                        <span>Chat</span>
                    </button>
                    <button mat-menu-item (click)="choosingTab('file')" [class.d-none]="choosed=='file'">
                        <span>Files</span>
                    </button>
                    <button mat-menu-item (click)="choosingTab('user')" [class.d-none]="choosed=='user'">
                        <span>Participants ({{ threadUsers.length }})</span>
                    </button>
                    <button mat-menu-item (click)="leaveChat()" *ngIf="isCurrentUserAdmin && !isCurrentUserOwner">
                        <span>Leave Chat</span>
                    </button>
                </mat-menu>

            </ng-container>
            <!-- <mat-icon [matTooltip]="'Leave'" *ngIf="isCurrentUserAdmin && !isCurrentUserOwner" (click)="leaveChat()"
                style="color: #f05f25;">exit_to_app</mat-icon> -->
            <ng-container *ngIf="!mobileView">
                <i class="flaticon-logout" [matTooltip]="'Leave Chat'" *ngIf="isCurrentUserAdmin && !isCurrentUserOwner"
                    (click)="leaveChat()"></i>
            </ng-container>
        </div>
    </div>
    <!-- <ng-container *ngIf="choosed=='chat'"> -->
    <div class="chatConvo" [class.d-none]="choosed!='chat'">
        <div class="scrolly" #scrollContainer>
            <div style="text-align: center;
                font-style: italic;
                font-size: small;
                cursor: pointer;" [ngClass]="disconSocket ? 'disconnectDiv' : ''">
                <span style="color: #ff9064; text-decoration: underline;" (click)="loadMoreMessages()"
                    *ngIf="showMoreMessages">Show Older Messages</span>
            </div>
            <div *ngFor="let chats of chatMessages" [ngClass]="disconSocket ? 'disconnectDiv' : ''">
                <div *ngIf="chats.sent_by == null" class="d-flex-vh-center w-100">
                    <div class="externalMessages" markdown [data]="chats.message">{{ chats.message }}</div>
                </div>
                <div *ngIf="chats.sent_by != null">
                    <div class="messageLeaf send" *ngIf="chats.sent_by?.id == current_user">
                        <div class="messageBoxSend">
                            <div class="replyMessageBox" style="display: none" id="{{ chats.id }}"
                                (mouseenter)="showReply(chats.id)" (mouseleave)="hideReply(chats.id)"
                                (mousewheel)="hideReply(chats.id)">
                                <div style="display: flex;">
                                    <div (click)="
                                            replyMessage(chats.id, chats.message,chats.sent_by?.first_name,chats.created_at, chats.documents)
                                        " class="replyEmoji">
                                        <mat-icon color="success">reply</mat-icon>
                                    </div>
                                    <div (click)="
                                            deleteChat(chats)
                                        " class="replyEmoji">
                                        <mat-icon color="warn">restore_from_trash</mat-icon>
                                    </div>
                                </div>
                                <span class="splitter sp1">|</span>
                                <ngx-emoji emoji=":heart::skin-tone-1:" (emojiClick)="addReplyEmoji($event, chats.id)"
                                    class="replyEmoji" [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":+1::skin-tone-1:" (emojiClick)="addReplyEmoji($event, chats.id)"
                                    class="replyEmoji" [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":thumbsdown::skin-tone-1:"
                                    (emojiClick)="addReplyEmoji($event, chats.id)" class="replyEmoji"
                                    [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":laughing::skin-tone-1:"
                                    (emojiClick)="addReplyEmoji($event, chats.id)" class="replyEmoji"
                                    [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":smiley::skin-tone-1:" (emojiClick)="addReplyEmoji($event, chats.id)"
                                    class="replyEmoji" [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":fire::skin-tone-1:" (emojiClick)="addReplyEmoji($event, chats.id)"
                                    class="replyEmoji" [isNative]="true"></ngx-emoji>
                            </div>

                            <div class="message" (mouseenter)="showReply(chats.id)" (mouseleave)="hideReply(chats.id)"
                                (mousewheel)="hideReply(chats.id)" (click)="checkForPS(chats.message)">
                                <div>
                                    <div style="font-size: 10px; color: #ff4d00; text-align: end; ">
                                        {{
                                        chats.created_at
                                        | date
                                        : "d-MMM h:mm a"
                                        }}
                                    </div>
                                    <div *ngIf="chats.replied_to != null" class="repliedTo">
                                        <div>
                                            <div style="
                                                    display: flex;
                                                    column-gap: 5px;
                                                ">
                                                <div style="
                                                        font-size: 10px;
                                                        color: #ff4d00;
                                                    ">
                                                    {{
                                                    chats.replied_to.sent_by
                                                    .first_name | titlecase
                                                    }}
                                                </div>
                                                <div style="
                                                        font-size: 10px;
                                                        color: #ff4d00;
                                                    ">
                                                    {{
                                                    chats.replied_to.created_at
                                                    | date
                                                    : "d-MMM h:mm a"
                                                    }}
                                                </div>
                                            </div>
                                            <div class="messagespan" markdown [data]="chats.replied_to.message">
                                                {{ chats.replied_to.message }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="messagespan" markdown [data]="chats.message">
                                        <span *ngIf="chats.message.includes('http') || chats.message.includes('www')"
                                            (click)="openLink(chats.message)" matTooltip="Click to view"
                                            style="color: black !important"><u>{{ chats.message
                                                }}</u></span>
                                        <span *ngIf="!chats.message.includes('http') && !chats.message.includes('www')">
                                            {{ chats.message }}</span>
                                    </div>
                                    <div *ngFor="let document of chats.documents" class="attachedDocuments"
                                        matTooltip="Click to view & download">
                                        <div *ngIf="allowedImageExt.includes(document.extension)" class="images"
                                            (click)="downloadDocument(document.document_file)">
                                            <logzy-img-loader [src]="document.document_file"></logzy-img-loader>
                                        </div>
                                        <div *ngIf="!allowedImageExt.includes(document.extension)" class="file"
                                            (click)="downloadDocument(document.document_file)">
                                            <span>
                                                {{ document.original_filename }}.{{ document.extension }}
                                            </span>
                                        </div>
                                    </div>
                                    <!-- <div style="text-align: end;"
                                            [ngStyle]="{'color': chats.message_seen_flag == true ? 'green' : 'grey'}"> -->
                                    <!-- <mat-icon style="font-size: medium;">done_all</mat-icon> -->
                                    <div class="messageStatus" [class.read]="chats.message_seen_flag == '0'">
                                        <i class="flaticon-tick check1"
                                            [class.delivered]="chats.message_seen_flag == '1' || chats.message_seen_flag == '0'"></i>
                                        <i class="flaticon-tick check2" [class.send]="true"></i>
                                    </div>
                                    <!-- </div> -->
                                </div>
                            </div>
                            <ng-container *ngIf="objectKeys(chats.reactions).length > 0">
                                <div class="reactMessageBox" (mouseenter)="showReply(chats.id)"
                                    (mouseleave)="hideReply(chats.id)">
                                    <ng-container *ngFor="let reaction of chats.reactions | keyvalue">
                                        <div class="reactMessage">
                                            {{ reaction.key }}
                                            <span class="reactionCount">{{reaction.value.length}}</span>
                                            <div class="reactedUserList">
                                                <div class="reactedUserItem"
                                                    *ngFor="let reaction_item of reaction.value">
                                                    <div class="profile">
                                                        <logzy-img-loader src="{{
                                                            reaction_item.user?.picture == null
                                                                ? reaction_item.user?.gender == 'Male'
                                                                    ? base_url +
                                                                      '/media/profile_pics/man.svg'
                                                                    : reaction_item.user?.gender == 'Female'
                                                                    ? base_url +
                                                                      '/media/profile_pics/woman.svg'
                                                                    : base_url +
                                                                      '/media/profile_pics/default_dp.svg'
                                                                : reaction_item.user?.picture?.document_file
                                                        }}" border_radius="50%" [profilePic]="true" fontSize="12px"
                                                            [initials]="reaction_item.user?.initials" [class.p-0]="true"
                                                            [background_color]="reaction_item.user?.bg_color_code"
                                                            class="profile-logo-round"
                                                            [span_color]="reaction_item.user?.text_color_code">
                                                        </logzy-img-loader>
                                                        <div class="name">
                                                            <span>{{reaction_item.user.first_name}}</span><span>{{reaction_item.user.last_name}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                        <span class="messenger">
                            <logzy-img-loader src="{{
                                    chats.sent_by?.picture == null
                                        ? chats.sent_by?.gender == 'Male'
                                            ? base_url +
                                              '/media/profile_pics/man.svg'
                                            : chats.sent_by?.gender == 'Female'
                                            ? base_url +
                                              '/media/profile_pics/woman.svg'
                                            : base_url +
                                              '/media/profile_pics/default_dp.svg'
                                        : chats.sent_by?.picture?.document_file
                                }}" border_radius="50%" [profilePic]="true" [initials]="chats.sent_by?.initials"
                                class="profile-logo-round" [class.p-0]="true"
                                [background_color]="chats.sent_by?.bg_color_code"
                                [span_color]="chats.sent_by?.text_color_code">
                            </logzy-img-loader>
                        </span>
                    </div>
                    <div class="messageLeaf received" *ngIf="chats.sent_by?.id != current_user">
                        <div class="messageBoxReceived">
                            <span class="senderName">{{chats.sent_by?.first_name}} {{chats.sent_by?.last_name}}</span>
                            <div class="replyMessageBox" style="display: none" id="{{ chats.id }}"
                                (mouseenter)="showReply(chats.id)" (mouseleave)="hideReply(chats.id)"
                                (mousewheel)="hideReply(chats.id)">
                                <div style="display: flex">
                                    <div (click)="
                                            replyMessage(chats.id, chats.message,chats.sent_by?.first_name,chats.created_at, chats.documents)
                                        " class="replyEmoji">
                                        <mat-icon color="success">reply</mat-icon>

                                    </div>
                                </div>
                                <span class="splitter sp2">|</span>
                                <ngx-emoji emoji=":heart::skin-tone-1:" (emojiClick)="addReplyEmoji($event, chats.id)"
                                    class="replyEmoji" [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":+1::skin-tone-1:" (emojiClick)="addReplyEmoji($event, chats.id)"
                                    class="replyEmoji" [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":thumbsdown::skin-tone-1:"
                                    (emojiClick)="addReplyEmoji($event, chats.id)" class="replyEmoji"
                                    [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":laughing::skin-tone-1:"
                                    (emojiClick)="addReplyEmoji($event, chats.id)" class="replyEmoji"
                                    [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":smiley::skin-tone-1:" (emojiClick)="addReplyEmoji($event, chats.id)"
                                    class="replyEmoji" [isNative]="true"></ngx-emoji>
                                <ngx-emoji emoji=":fire::skin-tone-1:" (emojiClick)="addReplyEmoji($event, chats.id)"
                                    class="replyEmoji" [isNative]="true"></ngx-emoji>
                            </div>
                            <div class="message" (mouseenter)="showReply(chats.id)" (mouseleave)="hideReply(chats.id)"
                                (mousewheel)="hideReply(chats.id)" (click)="checkForPS(chats.message)">
                                <div>
                                    <div style="font-size: 10px; color: #ff4d00; text-align:end">
                                        {{
                                        chats.created_at
                                        | date
                                        : "d-MMM h:mm a"
                                        }}
                                    </div>
                                    <div *ngIf="chats.replied_to != null" class="repliedTo">
                                        <div>
                                            <div style="
                                                    display: flex;
                                                    column-gap: 5px;
                                                ">
                                                <div style="
                                                        font-size: 10px;
                                                        color: #ff4d00;
                                                    ">
                                                    {{
                                                    chats.replied_to.sent_by
                                                    .first_name | titlecase
                                                    }}
                                                </div>
                                                <div style="
                                                        font-size: 10px;
                                                        color: #ff4d00;
                                                    ">
                                                    {{
                                                    chats.replied_to.created_at
                                                    | date
                                                    : "d-MMM h:mm a"
                                                    }}
                                                </div>
                                            </div>
                                            <div class="messagespan" markdown [data]="chats.replied_to.message">
                                                {{ chats.replied_to.message }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="messagespan" markdown [data]="chats.message">
                                        <span
                                            *ngIf="chats.message.includes('http') || chats.message.includes('www') || chats"
                                            (click)="openLink(chats.message)" matTooltip="Click to view"
                                            style="color: black !important"><u>{{ chats.message
                                                }}</u></span>
                                        <span
                                            *ngIf="!chats.message.includes('http') && !chats.message.includes('www')">{{
                                            chats.message }}</span>
                                    </div>
                                    <div *ngFor="let document of chats.documents" class="attachedDocuments"
                                        matTooltip="Click to view & download">
                                        <div *ngIf="allowedImageExt.includes(document.extension)" class="images"
                                            (click)="downloadDocument(document.document_file)">
                                            <logzy-img-loader [src]="document.document_file"></logzy-img-loader>
                                        </div>
                                        <div *ngIf="!allowedImageExt.includes(document.extension)" class="file"
                                            (click)="downloadDocument(document.document_file)">
                                            <span>
                                                {{ document.original_filename }}.{{ document.extension }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngIf="objectKeys(chats.reactions).length > 0">
                                <div class="reactMessageBox" (mouseenter)="showReply(chats.id)"
                                    (mouseleave)="hideReply(chats.id)">
                                    <ng-container *ngFor="let reaction of chats.reactions | keyvalue">
                                        <div class="reactMessage">
                                            {{ reaction.key }}
                                            <span class="reactionCount">{{reaction.value.length}}</span>
                                            <div class="reactedUserList">
                                                <div class="reactedUserItem"
                                                    *ngFor="let reaction_item of reaction.value">
                                                    <div class="profile">
                                                        <logzy-img-loader src="{{
                                                            reaction_item.user?.picture == null
                                                                ? reaction_item.user?.gender == 'Male'
                                                                    ? base_url +
                                                                      '/media/profile_pics/man.svg'
                                                                    : reaction_item.user?.gender == 'Female'
                                                                    ? base_url +
                                                                      '/media/profile_pics/woman.svg'
                                                                    : base_url +
                                                                      '/media/profile_pics/default_dp.svg'
                                                                : reaction_item.user?.picture?.document_file
                                                        }}" border_radius="50%" [profilePic]="true" fontSize="12px"
                                                            class="profile-logo-round"
                                                            [initials]="reaction_item.user?.initials" [class.p-0]="true"
                                                            [background_color]="reaction_item.user?.bg_color_code"
                                                            [span_color]="reaction_item.user?.text_color_code">
                                                        </logzy-img-loader>
                                                        <div class="name">
                                                            <span>{{reaction_item.user.first_name}}</span><span>{{reaction_item.user.last_name}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                        <span class="messenger">
                            <logzy-img-loader src="{{
                                chats.sent_by?.picture == null
                                    ? chats.sent_by?.gender == 'Male'
                                        ? base_url +
                                          '/media/profile_pics/man.svg'
                                        : chats.sent_by?.gender == 'Female'
                                        ? base_url +
                                          '/media/profile_pics/woman.svg'
                                        : base_url +
                                          '/media/profile_pics/default_dp.svg'
                                    : chats.sent_by?.picture?.document_file
                            }}" border_radius="50%" [profilePic]="true" [initials]="chats.sent_by?.initials"
                                class="profile-logo-round" [class.p-0]="true"
                                [background_color]="chats.sent_by?.bg_color_code"
                                [span_color]="chats.sent_by?.text_color_code">
                            </logzy-img-loader>
                        </span>
                    </div>
                </div>
            </div>
            <span markdown [data]="userIsTyping" style="text-align: center; color: #ff9064; font-size: 10px;">{{
                userIsTyping }}</span>
        </div>
    </div>
    <div class="inputBox" [class.d-none]="choosed!='chat'" [ngClass]="disconSocket ? 'disconnectDiv' : ''">
        <div class="inputTextArea">
            <quill-editor [styles]="{'min-height': '50px'}" [(ngModel)]="message" (blur)="onBlur()" (focus)="onFocus()"
                (click)="onFocus()" id="message" [modules]="modules" #editor
                placeholder="Type your message here..........." style="width: inherit;" (input)="onKeyUp($event)"
                (keyup.backspace)="checkTyping($event)" (keydown)="checkAltAndShiftEnter($event)"
                (paste)="savePrintScreen($event)">
            </quill-editor>
            <!-- <quill-view-html *ngIf="displayFile || replyFlag" [content]="replyToMessage" theme="snow"></quill-view-html> -->
            <!-- <app-text-field [isMultiline]="false" [isEditable]="true" [name]="'description'"
                    [placeholder]="disconSocket ? 'Chat Disconnected........' : 'Write your message here...'" class=""
                    [(ngModel)]="message" (keyup.enter)="checkMessageType()" (blur)="onBlur()" (focus)="onFocus()"
                    (click)="onFocus()" id="message" [(chatBox)]="replyFlag" [replyingName]="replyingName"
                    [replyingToTiming]="replyingToTiming" [replyingto]="replyingto" [(showFile)]="displayFile"
                    [(uploadFile)]="uploadedFiles" #chatterBox (input)="onKeyUp($event)"
                    (keyup.backspace)="getRemovedMessages($event)">
                </app-text-field> -->
            <!-- <div style="position: absolute; z-index: 1; bottom: 14%;">
                <ul *ngIf="showSuggestions" #mentionsBox>
                    <ol *ngFor="let user of mentionFilteredData | mentions: message" (click)="selectUser(user)">
                            <logzy-img-loader src="{{
                                user.user?.picture == null
                                    ? user.user?.gender == 'Male'
                                        ? base_url +
                                          '/media/profile_pics/man.svg'
                                        : user.user?.gender == 'Female'
                                        ? base_url +
                                          '/media/profile_pics/woman.svg'
                                        : base_url +
                                          '/media/profile_pics/default_dp.svg'
                                    : user.user?.picture?.document_file
                            }}" border_radius="50%" [profilePic]="true" fontSize="12px" class="profile-logo-round"
                                [initials]="user.user?.initials" [class.p-0]="true"
                                [background_color]="user.user?.bg_color_code" [span_color]="user.user?.text_color_code">
                            </logzy-img-loader>
    
                            <div class="mentionDetails">
                            <div>
                                {{ user.user.first_name + ' ' + user.user.last_name }}
                            </div>
                            <div class="email">
                                {{ user.user.email }}
                            </div>
                            </div>
    
                    </ol>
                </ul>
            </div> -->
            <!-- <ng-container *ngIf="displayFile || replyFlag"> -->

            <logzy-reply-doc-station [(chatBox)]="replyFlag" [replyingName]="replyingName"
                [replyingToTiming]="replyingToTiming" [replyingto]="replyingto" [(showFile)]="displayFile"
                [(uploadFile)]="uploadedFiles" [loading]="docLoading"></logzy-reply-doc-station>
            <!-- <app-text-field [isMultiline]="false" [isEditable]="true" [name]="'description'" class=""
                    [(ngModel)]="replyToMessage" [(chatBox)]="replyFlag" [replyingName]="replyingName"
                    [replyingToTiming]="replyingToTiming" [replyingto]="replyingto" [(showFile)]="displayFile"
                    [(uploadFile)]="uploadedFiles" onpaste="return false;" onkeydown="return false;">
                </app-text-field> -->
            <!-- </ng-container> -->
        </div>
        <div class="inputBoxFoot">
            <div class="emojiContainer">
                <div class="emojiPicker">
                    <span (click)="toggleEmojiPicker()" #toogleEmojiButton>😀</span>
                    <app-file-field [showUploadedList]="false" [fileDropArea]="false" [isEditable]="false"
                        [clipIcon]="true" [(ngModel)]="uploadedFiles" (ngModelChange)="getFiles($event)"
                        [documentTypeDevName]="'chat_documents'" [name]="'chatDoc'"
                        (loadingFileChange)="enableDocLoad($event)">
                    </app-file-field>
                </div>
                <div #emojiPickerPopup class="emoji-click">
                    <div class="emojiBox" *ngIf="showEmojiPicker">
                        <emoji-mart class="emoji-mart" (emojiSelect)="addEmoji($event)" title="Pick your emoji…"
                            i18n="i18n" [darkMode]="false" [isNative]="true" navPosition="none"
                            [showPreview]="false"></emoji-mart>
                    </div>
                </div>
            </div>
            <button mat-icon-button color="primary" (click)="sendMessage()" matTooltip="Send Message">
                <i class="flaticon-share-details">
                </i>
            </button>
        </div>

    </div>
    <!-- </ng-container> -->
    <!-- <ng-container *ngIf="choosed=='file'"> -->
    <div class="DocSection" [class.d-none]="choosed!='file'">
        <!-- <div class="totalDoc">
                <span>Total Documents Uploaded: {{ uploadedDocumentsCount }}</span> 
            </div> -->
        <mat-tab-group>
            <mat-tab label="All ({{ uploadedDocumentsCount }})">
                <div style="margin: 2%; color: grey; position: absolute;
                    width: 12em;">
                    <span *ngIf="sentDocumentsDetails.length == 0" style="margin: 1%">No files uploaded</span>
                </div>
                <div class="tabSpace">
                    <div class="tabRow" fxFlex="100" *ngFor="let doc of sentDocumentsDetails"
                        (click)="downloadDocument(doc.document_file)" style="cursor: pointer">
                        <logzy-img-loader [src]="'/assets/images/icons/file-type/'+doc.extension+'.svg'">
                        </logzy-img-loader>
                        <div class="doc">
                            <div class="title">
                                <span>{{ doc.original_filename}}.{{doc.extension }}</span>
                            </div>
                            <span class="uploader">Uploaded By:
                                <div>
                                    <b>{{ doc.created_by.first_name + ' ' + doc.created_by.last_name }}</b>
                                </div>
                            </span>
                            <span class="timestamp">
                                <b> ({{ doc.created_at | date: "d-MMM h:mm a" }}) </b>
                            </span>
                        </div>
                    </div>
                    <div style="margin-right: 5%; font-size: 11px; color: #f05f25; cursor: pointer;">
                        <i *ngIf="uploadedDocumentsCount != sentDocumentsDetails.length" (click)="loadMoreDocuments()"
                            matTooltip="Load More Documents">Show More...</i>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Docs" [disabled]="sentDocumentsDetails.length == 0">
                <div class="tabSpace">
                    <div class="tabRow" fxFlex="100" *ngFor="let doc of sentDocumentsDetails"
                        (click)="downloadDocument(doc.document_file)">
                        <div class="tabRow" fxFlex="100" *ngIf="doc.extension != 'png'
                            && doc.extension != 'jpg'" style="cursor: pointer">
                            <logzy-img-loader [src]="'/assets/images/icons/file-type/'+doc.extension+'.svg'">
                            </logzy-img-loader>
                            <div class="doc">
                                <div class="title">
                                    <span>{{ doc.original_filename}}.{{doc.extension }}</span>
                                </div>
                                <span class="uploader">Uploaded By:
                                    <div>
                                        <b>{{ doc.created_by.first_name + ' ' + doc.created_by.last_name }}</b>
                                    </div>
                                </span>
                                <span class="timestamp">
                                    <b> ({{ doc.created_at | date: "d-MMM h:mm a" }}) </b>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style="margin-right: 5%; font-size: 11px; color: #f05f25; cursor: pointer;">
                        <i *ngIf="uploadedDocumentsCount != sentDocumentsDetails.length" (click)="loadMoreDocuments()"
                            matTooltip="Load More Documents">Show More...</i>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Photos" [disabled]="sentDocumentsDetails.length == 0">
                <div class="tabSpace">
                    <div class="tabRow" fxFlex="100" *ngFor="let doc of sentDocumentsDetails">
                        <div class="tabRow" fxFlex="100" *ngIf="doc.extension == 'png' || doc.extension == 'jpg'"
                            (click)="downloadDocument(doc.document_file)" style="cursor: pointer">
                            <logzy-img-loader [src]="'/assets/images/icons/file-type/'+doc.extension+'.svg'">
                            </logzy-img-loader>
                            <div class="doc">
                                <div class="title">
                                    <span>{{ doc.original_filename}}.{{doc.extension }}</span>
                                </div>
                                <span class="uploader">Uploaded By:
                                    <div>
                                        <b>{{ doc.created_by.first_name + ' ' + doc.created_by.last_name }}</b>
                                    </div>
                                </span>
                                <span class="timestamp">
                                    <b> ({{ doc.created_at | date: "d-MMM h:mm a" }}) </b>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style="margin-right: 5%; font-size: 11px; color: #f05f25; cursor: pointer;">
                        <i *ngIf="uploadedDocumentsCount != sentDocumentsDetails.length" (click)="loadMoreDocuments()"
                            matTooltip="Load More Documents">Show More...</i>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div *ngIf="compact" [class.d-none]="choosed!='user'" class="participantOptions">
        <div class="parTitle" [ngClass]="addingUser ? 'parTitle1' : 'parTitle'">
            <ng-container *ngIf="!addingUser">
                <span>{{ threadUsers.length }} Participants</span>
                <i class="flaticon-add-user" matTooltip="Add Participants" (click)="toggleAddUser()"
                    *ngIf="isCurrentUserAdmin"></i>
            </ng-container>
            <ng-container *ngIf="addingUser">
                <app-mat-auto-search [isEditable]="true" [(ngModel)]="selectedUser" [displayField]="'first_name'"
                    [setSearchValue]="false" [name]="'email'" [idField]="null"
                    [listUrl]="usersList_url+'user_list/?search=::search::&exclude_users=' + excludedUsers + userFilterParam"
                    fxFlex="12em" placeholder="Search User" [clearable]="true" [labelItemTemplate]="userSelectedItem"
                    [itemTemplate]="userItem">
                </app-mat-auto-search>
                <button mat-raised-button (click)="addUserInChat()" class="addBtn" *ngIf="selectedUser">
                    Add
                </button>
                <button mat-raised-button (click)="toggleAddUser()" class="addBtn" *ngIf="!selectedUser">
                    Cancel
                </button>
            </ng-container>
        </div>
        <div class="participantsBox" [class.d-none]="choosed=='users'">
            <div class="participants" *ngFor="let user of threadUsers">
                <div class="user">
                    <logzy-img-loader src="{{
                            user.user?.picture == null
                                ? user.user?.gender == 'Male'
                                    ? base_url +
                                      '/media/profile_pics/man.svg'
                                    : user.user?.gender == 'Female'
                                    ? base_url +
                                      '/media/profile_pics/woman.svg'
                                    : base_url +
                                      '/media/profile_pics/default_dp.svg'
                                : user.user?.picture?.document_file
                        }}" border_radius="50%" [profilePic]="true" fontSize="12px" [initials]="user.user?.initials"
                        class="profile-logo-round" [class.p-0]="true" [background_color]="user.bg_color_code"
                        [span_color]="user.text_color_code">
                    </logzy-img-loader>
                    <span *ngIf="user.is_admin">
                        <i [class]="user.is_owner ? 'flaticon-ribbon owner' : 'flaticon-ribbon'"
                            [matTooltip]="user.is_owner ? 'Owner' : 'Admin'"></i>
                    </span>
                    <span class="userName">{{ user.user.first_name + ' ' + user.user.last_name}}</span>
                </div>
                <ng-container *ngIf="isCurrentUserAdmin && !user.is_owner">
                    <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="user.user.id != current_user">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngIf="user.user.id != current_user">
                            <span class="matSpan" (click)="removeParticipant(user)">Remove user</span>
                        </button>
                        <button mat-menu-item *ngIf="(user.user.id != current_user) && !user.is_admin">
                            <span class="matSpan" (click)="addEditRoles(user, true)">Make Admin</span>
                        </button>
                        <button mat-menu-item *ngIf="(user.user.id != current_user) && user.is_admin">
                            <span class="matSpan" (click)="addEditRoles(user, false)">Remove Admin</span>
                        </button>
                        <!-- <button mat-menu-item *ngIf="user.user.id == current_user">
                            <span class="matSpan" (click)="leaveChat(user)">Leave</span>
                        </button> -->
                    </mat-menu>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- </ng-container> -->
</div>
<ng-container *ngIf="!compact">
    <div class="chatOptions" *ngIf="!chatBoxMax" fxFlex="25" [class.blur-effect]="chatService.noAccessToChat">
        <div class="participantOptions" fxFlex="50">
            <!-- <div class="logo">
                <div class="cover">
                    <i class="flaticon-chat"></i>
                </div>
            </div> -->
            <div class="parTitle" [ngClass]="addingUser ? 'parTitle1' : 'parTitle'">
                <ng-container *ngIf="!addingUser">
                    <span>{{ threadUsers.length }} Participants</span>
                    <i class="flaticon-add-user" matTooltip="Add Participants" (click)="toggleAddUser()"
                        *ngIf="isCurrentUserAdmin"></i>
                </ng-container>
                <ng-container *ngIf="addingUser">
                    <app-mat-auto-search [isEditable]="true" [(ngModel)]="selectedUser" [displayField]="'first_name'"
                        [setSearchValue]="false" [name]="'email'" [idField]="null"
                        [listUrl]="usersList_url+'user_list/?search=::search::&exclude_users=' + excludedUsers + userFilterParam"
                        fxFlex="12em" placeholder="Search User" [clearable]="true"
                        [labelItemTemplate]="userSelectedItem" [itemTemplate]="userItem">
                    </app-mat-auto-search>
                    <button mat-raised-button (click)="addUserInChat()" class="addBtn" *ngIf="selectedUser">
                        Add
                    </button>
                    <button mat-raised-button (click)="toggleAddUser()" class="addBtn" *ngIf="!selectedUser">
                        Cancel
                    </button>
                </ng-container>
            </div>
            <div class="participantsBox">
                <div class="participants" *ngFor="let user of threadUsers">
                    <div class="user">
                        <logzy-img-loader src="{{
                                user.user?.picture == null
                                    ? user.user?.gender == 'Male'
                                        ? base_url +
                                          '/media/profile_pics/man.svg'
                                        : user.user?.gender == 'Female'
                                        ? base_url +
                                          '/media/profile_pics/woman.svg'
                                        : base_url +
                                          '/media/profile_pics/default_dp.svg'
                                    : user.user?.picture?.document_file
                            }}" border_radius="50%" [profilePic]="true" fontSize="12px"
                            [initials]="user.user?.initials" class="profile-logo-round" [class.p-0]="true"
                            [background_color]="user.bg_color_code" [span_color]="user.text_color_code">
                        </logzy-img-loader>
                        <span *ngIf="user.is_admin">
                            <i [class]="user.is_owner ? 'flaticon-ribbon owner' : 'flaticon-ribbon'"
                                [matTooltip]="user.is_owner ? 'Owner' : 'Admin'"></i>
                        </span>
                        <span class="userName">{{ user.user.first_name + ' ' + user.user.last_name}}</span>
                    </div>
                    <ng-container *ngIf="isCurrentUserAdmin && !user.is_owner">
                        <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="user.user.id != current_user">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item *ngIf="user.user.id != current_user">
                                <span class="matSpan" (click)="removeParticipant(user)">Remove user</span>
                            </button>
                            <button mat-menu-item *ngIf="(user.user.id != current_user) && !user.is_admin">
                                <span class="matSpan" (click)="addEditRoles(user, true)">Make Admin</span>
                            </button>
                            <button mat-menu-item *ngIf="(user.user.id != current_user) && user.is_admin">
                                <span class="matSpan" (click)="addEditRoles(user, false)">Remove Admin</span>
                            </button>
                            <!-- <button mat-menu-item *ngIf="user.user.id == current_user">
                                <span class="matSpan" (click)="leaveChat(user)">Leave</span>
                            </button> -->
                        </mat-menu>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="DocSection" fxFlex="50">
            <!-- <div class="totalDoc">
                <span>Total Documents Uploaded: {{ uploadedDocumentsCount }}</span> 
            </div> -->
            <mat-tab-group>
                <mat-tab label="All ({{ uploadedDocumentsCount }})">
                    <div style="margin: 2%; color: grey; position: absolute;
                    width: 12em;">
                        <span *ngIf="sentDocumentsDetails.length == 0" style="margin: 1%">No files uploaded</span>
                    </div>
                    <div class="tabSpace">
                        <div class="tabRow" fxFlex="100" *ngFor="let doc of sentDocumentsDetails"
                            (click)="downloadDocument(doc.document_file)" style="cursor: pointer">
                            <logzy-img-loader [src]="'/assets/images/icons/file-type/'+doc.extension+'.svg'">
                            </logzy-img-loader>
                            <div class="doc">
                                <div class="title">
                                    <span>{{ doc.original_filename}}.{{doc.extension }}</span>
                                </div>
                                <span class="uploader">Uploaded By:
                                    <div>
                                        <b>{{ doc.created_by.first_name + ' ' + doc.created_by.last_name }}</b>
                                    </div>
                                </span>
                                <span class="timestamp">
                                    <b> ({{ doc.created_at | date: "d-MMM h:mm a" }}) </b>
                                </span>
                            </div>
                        </div>
                        <div style="margin-right: 5%; font-size: 11px; color: #f05f25; cursor: pointer;">
                            <i *ngIf="uploadedDocumentsCount != sentDocumentsDetails.length"
                                (click)="loadMoreDocuments()" matTooltip="Load More Documents">Show More...</i>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Docs" [disabled]="sentDocumentsDetails.length == 0">
                    <div class="tabSpace">
                        <div class="tabRow" fxFlex="100" *ngFor="let doc of sentDocumentsDetails"
                            (click)="downloadDocument(doc.document_file)">
                            <div class="tabRow" fxFlex="100" *ngIf="doc.extension != 'png'
                            && doc.extension != 'jpg'" style="cursor: pointer">
                                <logzy-img-loader [src]="'/assets/images/icons/file-type/'+doc.extension+'.svg'">
                                </logzy-img-loader>
                                <div class="doc">
                                    <div class="title">
                                        <span>{{ doc.original_filename}}.{{doc.extension }}</span>
                                    </div>
                                    <span class="uploader">Uploaded By:
                                        <div>
                                            <b>{{ doc.created_by.first_name + ' ' + doc.created_by.last_name }}</b>
                                        </div>
                                    </span>
                                    <span class="timestamp">
                                        <b> ({{ doc.created_at | date: "d-MMM h:mm a" }}) </b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div style="margin-right: 5%; font-size: 11px; color: #f05f25; cursor: pointer;">
                            <i *ngIf="uploadedDocumentsCount != sentDocumentsDetails.length"
                                (click)="loadMoreDocuments()" matTooltip="Load More Documents">Show More...</i>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Photos" [disabled]="sentDocumentsDetails.length == 0">
                    <div class="tabSpace">
                        <div class="tabRow" fxFlex="100" *ngFor="let doc of sentDocumentsDetails">
                            <div class="tabRow" fxFlex="100" *ngIf="doc.extension == 'png' || doc.extension == 'jpg'"
                                (click)="downloadDocument(doc.document_file)" style="cursor: pointer">
                                <logzy-img-loader [src]="'/assets/images/icons/file-type/'+doc.extension+'.svg'">
                                </logzy-img-loader>
                                <div class="doc">
                                    <div class="title">
                                        <span>{{ doc.original_filename}}.{{doc.extension }}</span>
                                    </div>
                                    <span class="uploader">Uploaded By:
                                        <div>
                                            <b>{{ doc.created_by.first_name + ' ' + doc.created_by.last_name }}</b>
                                        </div>
                                    </span>
                                    <span class="timestamp">
                                        <b> ({{ doc.created_at | date: "d-MMM h:mm a" }}) </b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div style="margin-right: 5%; font-size: 11px; color: #f05f25; cursor: pointer;">
                            <i *ngIf="uploadedDocumentsCount != sentDocumentsDetails.length"
                                (click)="loadMoreDocuments()" matTooltip="Load More Documents">Show More...</i>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</ng-container>
<!-- </div> -->
<ng-template #userItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="userListShow">
        <span class="fullname">
            {{item.first_name}} {{item.last_name}}
        </span>
        <span class="email">
            {{item.email}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{item.first_name}} {{item.last_name}}
</ng-template>